import { createForm } from "@tanstack/solid-form";
import { produce } from "solid-js/store";
import z from "zod";
import { useI18n } from "@/api/i18n";
import { FieldContainer, FieldInfo, Input } from "@/components/ui/input";
import { useOnboardingStore } from "../../context/OnboardingContext";
import { OnboardingDescription, OnboardingTitle } from "../shared/text";

const validationSchema = z.object({
  job_title: z
    .string()
    .min(1, { message: "Il titolo del lavoro è obbligatorio" })
    .max(150, {
      message: "Il titolo del lavoro deve essere minore di 150 caratteri",
    }),
});

export const JobTitle = () => {
  const [store, setStore] = useOnboardingStore();
  const { t } = useI18n();

  const form = createForm(() => ({
    defaultValues: {
      job_title: store.job_title.value,
    },
    onSubmit: ({ value }) => {
      const validatedData = validationSchema.safeParse(value);
      if (!validatedData.success) {
        console.error("Validation error", validatedData.error);
        return;
      }
      setStore(
        produce((draft) => {
          draft.job_title.value = validatedData.data.job_title;
          draft.job_title.error = null;
        }),
      );
    },
  }));

  return (
    <div class="flex flex-col gap-8 w-full">
      <div class="flex flex-col gap-4">
        <OnboardingTitle>
          {t("onboarding.steps.job_title.title")}
        </OnboardingTitle>
        <OnboardingDescription>
          {t("onboarding.steps.job_title.description")}
        </OnboardingDescription>
      </div>
      <div class="flex gap-4 justify-between items-end">
        <div class="flex flex-col w-full md:w-2/3">
          <form.Field
            name="job_title"
            validators={{
              onChange: ({ value }) => {
                const result =
                  validationSchema.shape.job_title.safeParse(value);
                if (result.success) {
                  setStore(
                    produce((draft) => {
                      draft.job_title.value = value;
                      draft.job_title.error = null;
                    }),
                  );
                  return undefined;
                }
                setStore(
                  produce((draft) => {
                    draft.job_title.value = value;
                    draft.job_title.error = result.error.issues[0].message;
                  }),
                );
                return result.error.issues[0].message;
              },
            }}
          >
            {(field) => (
              <FieldContainer>
                <Input
                  placeholder={t("onboarding.steps.job_title.placeholder")}
                  value={field().state.value ?? ""}
                  onInput={(e) => field().handleChange(e.target.value)}
                  onBlur={() => field().handleBlur()}
                  onChange={(e) => field().handleChange(e.target.value)}
                  size="lg"
                />
                <FieldInfo field={field()} />
              </FieldContainer>
            )}
          </form.Field>
        </div>
      </div>
    </div>
  );
};
